module.exports = __webpack_public_path__ + "img/cat3.17b11feb.png";